'use client'

export const isImage = (fileType: string) => fileType.startsWith('image/')

export const isPdf = (fileType: string, fileName?: string) => {
  const normalisedFileType = fileType.toLowerCase().split(';')[0].trim()

  return (
    normalisedFileType === 'application/pdf' ||
    Boolean(fileName && /\.pdf$/i.test(fileName))
  )
}

export const isPptx = (fileType: string) =>
  fileType ===
  'application/vnd.openxmlformats-officedocument.presentationml.presentation'

export const isDocx = (fileType: string) =>
  fileType ===
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document'

export const isXlsx = (fileType: string) =>
  fileType ===
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'

export const isCsv = (fileType: string) =>
  fileType.toLowerCase().split(';')[0].trim() === 'text/csv' ||
  fileType.toLowerCase().split(';')[0].trim() === 'application/csv'

export const isJson = (fileType: string, fileName?: string) => {
  const normalisedFileType = fileType.toLowerCase().split(';')[0].trim()

  return (
    normalisedFileType === 'application/json' ||
    normalisedFileType === 'text/json' ||
    Boolean(fileName && /\.json$/i.test(fileName))
  )
}

export const isXls = (fileType: string) =>
  fileType === 'application/vnd.ms-excel'

/**
 * Detect HTML uploads by MIME type first, with a filename fallback for browsers
 * that submit generic content types.
 */
export const isHtml = (fileType: string, fileName?: string) => {
  const normalisedFileType = fileType.toLowerCase().split(';')[0].trim()

  return (
    normalisedFileType === 'text/html' ||
    normalisedFileType === 'application/xhtml+xml' ||
    Boolean(fileName && /\.(html?|xhtml)$/i.test(fileName))
  )
}

export const isAudio = (fileType: string) =>
  fileType.startsWith('audio/') ||
  fileType === 'audio/mpeg' ||
  fileType === 'audio/mp3' ||
  fileType === 'audio/mp4' ||
  fileType === 'audio/x-m4a' ||
  fileType === 'audio/wav' ||
  fileType === 'audio/webm'

export const supportsAudioPlayer = (fileType: string) => isAudio(fileType)

export const isConvertibleToPdf = (fileType: string) =>
  isPptx(fileType) || isDocx(fileType)

export const supportsPdfViewer = (fileType: string) =>
  isPdf(fileType) || isPptx(fileType) || isDocx(fileType)
